export class SpsaProdViewDto {
    operation: string;
    prevOp: string;
    inputCount: number;
    inVariantId: number;
    wipQty: number;
    lotNo: string;
    processType: string;
    inCountType: string;
    productName: string;
    workOrderNo: string;
    wastageQty: number; 
    physicalQty?: number;
    issuedQty?: number
    clubbedQty?: number;
    outVariantId?: number;
    outCountType?: string
    outputGrade?: string;
    inputQty?:number;
    outPutQty?:number;
    yieldPer?:number;
    inVariantName?:string;
    outVariantName?:string;
    inputCountName?:string;
    outputCountName?:string;

constructor(operation: string, prevOp: string, inputCount: number, inVariantId: number, wipQty: number, lotNo: string, processType: string, inCountType: string, productName: string, workOrderNo: string, wastageQty: number, physicalQty?: number, issuedQty?: number, clubbedQty?: number, outVariantId?: number, outCountType?: string, outputGrade?: string, inputQty?:number,
    outPutQty?:number,yieldPer?:number,inVariantName?:string,outVariantName?:string, inputCountName?:string,
    outputCountName?:string) {
    this.operation = operation;
    this.prevOp = prevOp;
    this.inputCount = inputCount;
    this.inVariantId = inVariantId;
    this.wipQty = wipQty;
    this.lotNo = lotNo;
    this.processType = processType;
    this.inCountType = inCountType;
    this.productName = productName;
    this.workOrderNo = workOrderNo;
    this.wastageQty = wastageQty;
    this.physicalQty = physicalQty;
    this.issuedQty = issuedQty;
    this.clubbedQty = clubbedQty;
    this.outVariantId = outVariantId;
    this.outCountType = outCountType;
    this.outputGrade = outputGrade;
    this.inputQty = inputQty;
    this.outPutQty = outPutQty;
    this.yieldPer = yieldPer;
    this.inVariantName = inVariantName;
    this.outVariantName = outVariantName;
    this.inputCountName = inputCountName;
    this.outputCountName = outputCountName;
}
}